import React from 'react';
export function PainSection() {
  return <section className="bg-gray-50 py-4 md:py-12 px-4" data-id="element-139">
      <div className="max-w-3xl mx-auto" data-id="element-140">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-6 text-center" data-id="element-141">
          ¿Te sentís identificado con esto?
        </h2>

        <div className="space-y-2 md:space-y-4 text-lg text-gray-700" data-id="element-142">
          <div className="bg-white p-3 md:p-5 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-143">
            <p className="font-medium" data-id="element-144">
              Querés aprender un oficio pero no sabés por dónde empezar.
            </p>
          </div>

          <div className="bg-white p-3 md:p-5 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-145">
            <p className="font-medium" data-id="element-146">
              Buscás planos y tutoriales por internet pero todo está incompleto
              o desorganizado.
            </p>
          </div>

          <div className="bg-white p-3 md:p-5 rounded-lg shadow-sm border-l-4 border-red-400" data-id="element-147">
            <p className="font-medium" data-id="element-148">
              Sentís que el sueldo no alcanza y necesitás generar ingresos extra
              con tus manos.
            </p>
          </div>
        </div>

        <div className="mt-4 md:mt-8 text-center" data-id="element-149">
          <p className="text-xl md:text-2xl font-bold text-gray-800" data-id="element-150">
            No es falta de ganas. <br className="md:hidden" data-id="element-151" />
            <span className="bg-yellow-200 px-2 py-1 inline-block mt-2 md:mt-0" data-id="element-152">
              Es que te falta un sistema completo con planos, guías y proyectos
              listos para construir y vender.
            </span>
          </p>
        </div>
      </div>
    </section>;
}